import * as Styled from './styles'
import { Props } from './interfaces'
import PrimaryButton from './sections/PrimaryButton'
import SecondaryButton from './sections/SecondaryButton'
import { ReactElement } from 'react'

const Modal = ({
  open,
  onClose,
  title,
  buttons,
  message,
  disclaimer,
  width,
  children,
}: Props): ReactElement => {
  const { primary: primaryButton, secondary: secondaryButton } = buttons

  return (
    open && (
      <Styled.Background>
        <Styled.Modal $width={width}>
          <Styled.Header>
            <Styled.Title>{title}</Styled.Title>
            {onClose && <Styled.Close onClick={onClose} />}
          </Styled.Header>
          <Styled.Text>{message}</Styled.Text>
          <Styled.SemiBoldText>{disclaimer}</Styled.SemiBoldText>
          {children}
          <Styled.Footer>
            {secondaryButton && (
              <SecondaryButton
                onClick={secondaryButton?.onClick}
                show={!!secondaryButton}
              >
                {secondaryButton?.text}
              </SecondaryButton>
            )}
            {primaryButton && (
              <PrimaryButton
                onClick={primaryButton?.onClick}
                show={!!primaryButton}
                type={primaryButton?.type}
                forWhatsApp={primaryButton?.forWhatsApp}
              >
                {primaryButton?.text}
              </PrimaryButton>
            )}
          </Styled.Footer>
        </Styled.Modal>
      </Styled.Background>
    )
  )
}

Modal.defaultProps = {
  width: '378px',
}

export default Modal
